import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, UntypedFormControl, Validators } from '@angular/forms';
import { AlertService } from '../../services/alert/alert.service';
import { LoadingService } from '../../services/loading/loading.service';
import { CustomerRegistrationService } from './../../services/customer-registration/customer-registration.service';
import { UserService } from '../../services/user/user.service';
import { ReportsService } from '../../services/reports/reports.service';
import { CommonValidators } from '../../shared/common-components/common-validators';
import AppConstants, { api_error, SOCI_INDICATOR } from '../../shared/common-components/AppConstants';
import * as FileSaver from 'file-saver';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { formatDate } from '@angular/common';
import { ExcelExportParams } from 'ag-grid-enterprise';
import {CommonHelpers} from "../../shared/common-helpers";
import {forkJoin} from "rxjs";
import {FrtAccessorialsMasterService} from "../../services/frt-accessorials-master/frt-accessorials-master.service";


@Component({
    selector: 'app-report-mailing-list',
    templateUrl: './report-mailing-list.component.html',
    styleUrls: ['./report-mailing-list.component.css'],
    standalone: false
})
export class ReportMailingListComponent implements OnInit {

  // MailingListReport: any = null;
  offerings: any;
  agencyUser: any;
  bureauUser: any;
  zipCode: any;
  mailingListForm: UntypedFormGroup;
  mailingListFormTemp: UntypedFormGroup;
  @ViewChild('malingListUsersModal', {static: true}) public malingListUsersModal: ModalDirective;
  message: string;
  hideSocioEconomicCheckbox = false;
  hideProcessingTsps = false;
  hideTspOfferings = false;
  agencyMasterList = [];
  agencySelected: any;
  agencyList = [];
  bureauMasterList = [];
  bureauMaster: any;
  tspSelected = false;
  freightTSPSelected = false;
  hhgTSPSelected = false;
  carrierUser: boolean;
  columnAPI:any;
  // Socio-Indicator array
  sociaEconomicIndicators = SOCI_INDICATOR;
  format = 'MM/dd/yyyy';
  locale = 'en-US';
  radioButtonList = [];
  radioButtonListFrt = [
    {name:"Freight Customers", value:"freightUser"},
    {name:"Freight Transportation Service Provider(TSP)", value:"freightTSP"},
  ];
  radioButtonListHhg = [
    {name:"Household Goods Customers", value:"hhGoodsUser"},
    {name:"Household Goods Transportation Service Provider(TSP)", value:"hhGoodsTSP"}
  ];
  radioSelectedValue: any;
  mailingReport: any;

  domLayout;
  paginationPageSize;
  errorMessage = '';
  // checkBoxPermisson = true;

  // This will be changed for now setting first column as sortOrder column
  order: any = null;
  reverse = false;
  currentUser: any;
  customerMailingListColumnDefs;
  tspMailingListColumnDefs;
  allUsersColumDefs;

  gridApi;
  detailCellRendererParams;
  customerMailingListReport : any;
  tspMailingListReport: any;
  allUsersMailListReport: any;
  excelStyles:any;
  smartWaySelected:boolean = false;
  // defaultExcelExportParams: ExcelExportParams;

  constructor(private reportsService: ReportsService,
    private userService: UserService,
    private customerRegistrationService: CustomerRegistrationService,
    private fb: UntypedFormBuilder, private alertService: AlertService,
    private frtAccessorialsMasterService: FrtAccessorialsMasterService,
    public loader: LoadingService) {
    this.getAllServiceOfferings();
    this.loader = loader;
    this.agencySelected = null;

    this.excelStyles = [
      {
        id: 'textFormat',
        dataType: 'string',
      }
    ];

    // this.paginationPageSize = 25;
    this.customerMailingListColumnDefs = [
      { headerName: 'Agency', field: 'agencyBureauName', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Bureau', field: 'bureauName', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Auth Official', colId: 'contact',
        valueGetter: function (params) {
            return params.data.firstName + ' ' + params.data.lastName;
            }, cellRenderer: 'agGroupCellRenderer' },
      { headerName: 'Address', field: 'addressLine1', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Address 2', field: 'addressLine2', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'City', field: 'city', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'State', field: 'stateCountryName', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Zip', field: 'zip', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Phone', field: 'phone', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Email', field: 'email', filter: 'agTextColumnFilter', sortable: true },
      {
        headerName: 'Agency Bureau Code', colId: 'agencyCode&bureauCode',
        valueGetter: function (params) {
          if (params.data.agencyCode !== '' && params.data.agencyCode !== null && params.data.agencyCode !== undefined &&
            params.data.bureauCode !== '' && params.data.bureauCode !== null && params.data.bureauCode !== undefined) {
            return (params.data.agencyCode + params.data.bureauCode).toString();
          }
        },
        filter: 'agTextColumnFilter',
        sortable: true,
        cellClass: 'textFormat'
      }
    ];

    this.tspMailingListColumnDefs = [
      { headerName: 'SCAC', field: 'scac', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'SCAC-Name', field: 'scacName', filter: 'agTextColumnFilter', sortable: true },
      {
        headerName: 'Domestic FRT',
        colId: 'DomesticFRT',
        filter: 'agTextColumnFilter',
        valueGetter : function(params: any){
          return (params.data.approvalDate) ? params.data.approvalDate : 'not approved';
        }
      },
      {
        headerName: 'Domestic HHG',
        colId: 'DomesticHHG',
        filter: 'agTextColumnFilter',
        valueGetter : function(params: any){
          return (params.data.approvalHHGMessage?.["Domestic HHG"]) ? params.data.approvalHHGMessage?.["Domestic HHG"] : '';
        }
      },
      {
        headerName: 'Extended Storage HHG',
        colId: 'ExtendedStorageHHG',
        filter: 'agTextColumnFilter',
        valueGetter : function(params: any){
          return (params.data.approvalHHGMessage?.["Extended Storage HHG"]) ? (params.data.approvalHHGMessage?.["Extended Storage HHG"]) : '';
        }
      },
      {
        headerName: 'International HHG',
        colId: 'InternationalHHG',
        filter: 'agTextColumnFilter',
        valueGetter : function(params: any){
          return (params.data.approvalHHGMessage?.["International HHG"]) ? (params.data.approvalHHGMessage?.["International HHG"]) : '';
        }
      },
      {
        headerName: 'Smartway',
        field: 'smartWayId',
        colId:'smartway',
        filter: 'agTextColumnFilter',
        minWidth: 80,
        maxWidth: 120,
        cellStyle: { 'text-align': 'center' },
        cellRenderer: params =>
          params.data.smartWayId === 1
            ? '<svg class="usa-icon define-text-green define-size-leaf" aria-hidden="true" focusable="false" role="img"><use xlink:href="/assets/uswds/img/sprite.svg#eco"></use></svg>'
            : ''
      },
      {
        headerName: 'Auth Official', colId: 'contact',
        valueGetter: function (params) {
          return params.data.firstName + ' ' + params.data.lastName;
        }, cellRenderer: 'agGroupCellRenderer'
      },
      { headerName: 'Address', field: 'addressLine1', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Address 2', field: 'addressLine2', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'City', field: 'city', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'State', field: 'stateCountryName', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Zip', field: 'zip', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Phone', field: 'phone', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Email', field: 'email', filter: 'agTextColumnFilter', sortable: true },

      { headerName: 'TSP Service Offerings', field: 'frtTspServiceOfferingsId', filter: 'agTextColumnFilter', sortable: true , colId : 'descriptionColumn'},
      {
        headerName: '(8a)',
        colId:'8a',
        width: 74,
        cellStyle: { 'text-align': 'center' },
        cellRenderer: function (params) {
          if(params.data?.scacEconomicIndicatorList?.sbiCertified8a === "1"){
            return '<svg class="usa-icon define-circle" aria-hidden="true" focusable="false" role="img"><use xlink:href="/assets/uswds/img/sprite.svg#radio_button_unchecked"></use></svg>';
          }
        }, filter: false
      },
      {
        headerName: '(d)',
        colId:'d',
        width: 74,
        cellStyle: { 'text-align': 'center' },
        cellRenderer: function (params) {
          if(params.data?.scacEconomicIndicatorList?.sbiCertifiedDisadvantged === "1"){
            return '<svg class="usa-icon define-circle" aria-hidden="true" focusable="false" role="img"><use xlink:href="/assets/uswds/img/sprite.svg#radio_button_unchecked"></use></svg>';
          }
        }, filter: false
      },
      {
        headerName: '(dv)',
        colId:'dv',
        width: 74,
        cellStyle: { 'text-align': 'center' },
        cellRenderer: function (params) {
          if(params.data?.scacEconomicIndicatorList?.serviceDisabledVetaranOwned === "1"){
            return '<svg class="usa-icon define-circle" aria-hidden="true" focusable="false" role="img"><use xlink:href="/assets/uswds/img/sprite.svg#radio_button_unchecked"></use></svg>';
          }
        }, filter: false
      },
      {
        headerName: '(h)',
        colId:'h',
        width: 74,
        cellStyle: { 'text-align': 'center' },
        cellRenderer: function (params) {
          if(params.data?.scacEconomicIndicatorList?.sbiCertifiedHUBZone === "1"){
            return '<svg class="usa-icon define-circle" aria-hidden="true" focusable="false" role="img"><use xlink:href="/assets/uswds/img/sprite.svg#radio_button_unchecked"></use></svg>';
          }
        }, filter: false
      },
      {
        headerName: '(o)',
        colId:'o',
        width: 74,
        cellStyle: { 'text-align': 'center' },
        cellRenderer: function (params) {
          if(params.data?.scacEconomicIndicatorList?.otherThanSmallBuisness === "1"){
            return '<svg class="usa-icon define-circle" aria-hidden="true" focusable="false" role="img"><use xlink:href="/assets/uswds/img/sprite.svg#radio_button_unchecked"></use></svg>';
          }
        }, filter: false
      },
      {
        headerName: '(s)',
        colId:'s',
        width: 74,
        cellStyle: { 'text-align': 'center' },
        cellRenderer: function (params) {
          if(params.data?.scacEconomicIndicatorList?.smallBusiness === "1"){
            return '<svg class="usa-icon define-circle" aria-hidden="true" focusable="false" role="img"><use xlink:href="/assets/uswds/img/sprite.svg#radio_button_unchecked"></use></svg>';
          }
        }, filter: false
      },
      {
        headerName: '(v)',
        colId:'v',
        width: 74,
        cellStyle: { 'text-align': 'center' },
        cellRenderer: function (params) {
          if(params.data?.scacEconomicIndicatorList?.vetaranOwnedBusiness === "1"){
            return '<svg class="usa-icon define-circle" aria-hidden="true" focusable="false" role="img"><use xlink:href="/assets/uswds/img/sprite.svg#radio_button_unchecked"></use></svg>';
          }
        }, filter: false
      },
      {
        headerName: '(w)',
        colId:'w',
        width: 74,
        cellStyle: { 'text-align': 'center' },
        cellRenderer: function (params) {
          if(params.data?.scacEconomicIndicatorList?.womenOwnedBusiness === "1"){
            return '<svg class="usa-icon define-circle" aria-hidden="true" focusable="false" role="img"><use xlink:href="/assets/uswds/img/sprite.svg#radio_button_unchecked"></use></svg>';
          }
        }, filter: false
      }
    ];
    this.allUsersColumDefs = [
      { headerName: 'First Name', field: 'firstName', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Last Name', field: 'lastName', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Phone', field: 'phone', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Email', field: 'email', filter: 'agTextColumnFilter', sortable: true },
      {
        headerName: 'Role',
        valueGetter: function (params) {
          return params.data.roles[0].role;
        }, filter: 'agTextColumnFilter', sortable: true
      },
      { headerName: 'User Status', field: 'status', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Last Login Date', field: 'lastLoginDate', filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Creation Date', field: 'createdDate', filter: 'agTextColumnFilter', sortable: true }

    ];


    this.detailCellRendererParams = {
      detailGridOptions: {
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: 'agTextColumnFilter',
          filterParams: {
            suppressAndOrCondition: true
          }
        },
        suppressAggFuncInHeader: true,
        pagination: true,
        paginationPageSize: 25,
        cacheBlockSize: 25,
        suppressDragLeaveHidesColumns: true,
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
        overlayNoRowsTemplate:
          '<span>No results found. Please adjust your filters.</span>',
        columnDefs: [
          { headerName: 'First Name', field: 'firstName', filter: 'agTextColumnFilter', sortable: true },
          { headerName: 'Last Name', field: 'lastName', filter: 'agTextColumnFilter', sortable: true },
          { headerName: 'Phone', field: 'phone', filter: 'agTextColumnFilter', sortable: true },
          { headerName: 'Email', field: 'email', filter: 'agTextColumnFilter', sortable: true },
          {
            headerName: 'Role',
            valueGetter: function (params) {
              return params.data.roles[0].role;
            }, filter: 'agTextColumnFilter', sortable: true
          },
          { headerName: 'User Status', field: 'status', filter: 'agTextColumnFilter', sortable: true },
          { headerName: 'Last Login Date', field: 'lastLoginDate', filter: 'agTextColumnFilter', sortable: true },
          { headerName: 'Creation Date', field: 'createdDate', filter: 'agTextColumnFilter', sortable: true }
        ],
        onFirstDataRendered(params) {
          params.api.sizeColumnsToFit();
        }
      },
      getDetailRowData: (params) => {
        this.reportsService.getAllUsersMailReport(params.data.organizationId).subscribe(
          usersList => {
            params.successCallback(usersList);
          },
          (error) => {
            this.errorMessage = error;
            this.alertService.error('No records found for the search criteria ');
            this.loader.hide();
          }
        );
      }
    };
  }

  processDataFromService(){
    if(this.freightTSPSelected === true){
      if(this.tspMailingListReport.length > 0){
        (this.tspMailingListReport).map((aTSPMail: any) => {
              aTSPMail.approvalDate = (aTSPMail.approvalDate) ? (formatDate(aTSPMail.approvalDate, this.format, this.locale)) : 'Not Approved';
          })
        }
    }
  }

  createForm() {
    // Create a FormControl for each available socia-echonomic indicators,
    // initialize them as unchecked, and put them in an array
    const formControls = this.sociaEconomicIndicators.map(control => new UntypedFormControl(false));
    const formControls1 = this.offerings.map(control => new UntypedFormControl(false));
    this.mailingListForm = this.fb.group({
      agencyUser: new UntypedFormControl(null),
      agencyCode: new UntypedFormControl(null),
      bureauUser: new UntypedFormControl(null),
      zipCode: new UntypedFormControl(null),
      sociaEconomicIndicators: new UntypedFormArray(formControls),
      offerings: new UntypedFormArray(formControls1),
      smartWay: new UntypedFormControl(null),
      processingTsps: new UntypedFormControl(null),
      allSocioEconIndicators: new UntypedFormControl(null),
      allServiceOfferings: new UntypedFormControl(null),
      mailingReport: new UntypedFormControl(null, Validators.required)
    },{
      validator: this.customValidateZipcode
    });
  }
  //numeric
  customValidateZipcode(group: UntypedFormGroup) {
    if (AppConstants.isNotNullCondition(group.controls['zipCode'].value!) && group.controls['zipCode'].value!.length > 0) {
      const zipcode = group.get('zipCode') as UntypedFormControl;
      const zipCodeErr =  (null != CommonValidators.lengthFive(zipcode)) ?
                (CommonValidators.lengthFive(zipcode)) : (null != CommonValidators.zipCode(zipcode)) ?
                  (CommonValidators.zipCode(zipcode)) : (null != CommonValidators.allZeros(zipcode)) ?
                  (CommonValidators.allZeros(zipcode)) : (CommonValidators.numeric(zipcode)) ? (CommonValidators.numeric(zipcode)) : null;
      group.get('zipCode').setErrors(zipCodeErr);
    }
  }

  getHhgRadioButtonList(role: string): any {
    return role !== 'System Admin' ? [this.radioButtonListHhg[1]] : this.radioButtonListHhg;
  }

  getAllServiceOfferings() {
    this.frtAccessorialsMasterService.getFrtServiceOfferings().subscribe(offerings => {
      this.offerings = offerings;
      this.createForm();
    }, (error) => {
      this.alertService.error('Error while getting offerings');
    });
  }

  ngOnInit() {
    // load the user details service to get the current user information.
    // Load Agency Users list DDL on page intial load and keep them in agencyMasterList and assign to agencyList.
    // This is to avoid multiple db calls when changing the Customer and/or TSP checkboxes
    this.loader.show();
    forkJoin([this.userService.getUserDetails(), this.customerRegistrationService.getAllAgency()]).subscribe(responses => {
      this.currentUser = responses[0];
      this.carrierUser = !this.currentUser.agencyUser;
      this.radioButtonList =  this.currentUser.permissions === 'HHG' ? this.getHhgRadioButtonList(this.currentUser.roles[0].role) :
        this.currentUser.permissions === 'FRT' ? this.radioButtonListFrt : this.radioButtonListHhg.concat(this.radioButtonListFrt);
      // To hide Socio Economic Indicators Check boxes when Customer check boxes are selected.
      this.hideSocioEconomicCheckbox = true;
      this.agencyMasterList = responses[1];
      this.agencyList = this.agencyMasterList;
      if (this.currentUser.agencyUser) {
        this.mailingListForm.get('mailingReport').setValue(this.radioButtonList[0]);
        this.radioButtonSelection(this.radioButtonList[0].value)
        this.mailingListForm.updateValueAndValidity();
      }
    }, err => {
      this.loader.hide();
      console.log('Error while getting the USPS details =>' + err);
      this.alertService.error('Error while getting the USPS address details');
    }, () => {
      this.loader.hide();
    });
  }

  radioButtonSelection(val: any){
    if(val){
      this.radioSelectedValue = val;
      if (this.radioSelectedValue === 'freightTSP' || this.radioSelectedValue === 'hhGoodsTSP') {
        this.hideSocioEconomicCheckbox = false;
      }
      if (this.radioSelectedValue === 'freightUser' || this.radioSelectedValue === 'hhGoodsUser') {
        this.mailingListForm.get('bureauUser').enable({ onlySelf: true, emitEvent: false });
        this.mailingListForm.get('agencyUser').enable({ onlySelf: true, emitEvent: false });
      }
      if (this.radioSelectedValue === 'freightTSP' || this.radioSelectedValue === 'hhGoodsTSP') {
        this.mailingListForm.get('bureauUser').disable({ onlySelf: true, emitEvent: false });
        this.mailingListForm.get('agencyUser').disable({ onlySelf: true, emitEvent: false });
        this.agencyList = [];
        this.bureauMaster = [];
      }
      if (this.radioSelectedValue !== 'freightTSP' && this.radioSelectedValue !== 'hhGoodsTSP') {
        this.mailingListForm.get('bureauUser').enable({ onlySelf: true, emitEvent: false });
        this.mailingListForm.get('agencyUser').enable({ onlySelf: true, emitEvent: false });
        this.agencyList = this.agencyMasterList;
        this.bureauMaster = this.bureauMasterList;
        this.hideSocioEconomicCheckbox = true;
      }

      if (this.radioSelectedValue === 'freightTSP' ) {
        this.hideProcessingTsps = false;
        this.hideTspOfferings = false;
      } else {
        this.hideProcessingTsps = true;
        this.hideTspOfferings = true;
      }
     // hideProcessingTsps = false;

      this.freightTSPSelected = (this.radioSelectedValue === 'freightTSP') ? true : false;
      this.hhgTSPSelected = (this.radioSelectedValue === 'hhGoodsTSP') ? true : false;
    }
  }
  onSocioEconomicChange(event) {
    (<UntypedFormArray>this.mailingListForm.get('sociaEconomicIndicators'))
      .controls
      .forEach(control => {
        if (event.target.checked) {
          control.disable();
          control.setValue(true);
        } else {
          control.enable();
          control.setValue(false);
        }
        control.updateValueAndValidity();
      });
  }

  onTspOfferingsChange(event) {
    (<UntypedFormArray>this.mailingListForm.get('offerings'))
      .controls
      .forEach(control => {
        if (event.target.checked) {
          control.disable();
          control.setValue(true);
        } else {
          control.enable();
          control.setValue(false);
        }
        control.updateValueAndValidity();
      });
  }

  // Trigger when Agecny user is selected
  changeAgency(event: any) {
    this.mailingListForm.get('agencyUser').setValue(event.item.agencyBureauName + ' - ' + event.item.agencyCode);
    this.mailingListForm.get('agencyCode').setValue(event.item.agencyCode);
    this.agencySelected = event.item.agencyCode;
    if (this.agencySelected !== null) {
      this.getBureauList(this.agencySelected);
    }
  }

  // Get the Bureau users list based on Agency user selected.
  getBureauList(agencyCode: any) {
    this.loader.show();
    this.customerRegistrationService.getAllBureauForAgency(agencyCode).subscribe(
      bureaus => {
        this.bureauMasterList = bureaus;
        this.bureauMaster = this.bureauMasterList;
        this.loader.hide();
        return this.bureauMaster;
      }, (error) => {
        this.alertService.error(api_error);
        this.loader.hide();
      });
  }

  // Trigger when Query button is clicked on Mailing list report.
  onSubmit() {
    if (!this.mailingListForm.valid) {
      return;
    }
    this.loader.show();
    if (this.radioSelectedValue === 'freightTSP' || this.radioSelectedValue === 'hhGoodsTSP') {
      this.tspSelected = true;
    } else {
      this.tspSelected = false;
    }

    this.errorMessage = '';
    this.customerMailingListReport = [];
    this.tspMailingListReport = [];
    const paramObj = this.constructParamsObj();
    if (this.tspSelected) {
      this.reportsService.getTSPMailReport(paramObj).subscribe(
        (mailReport) => {
          if(mailReport === null){
            this.alertService.error('No records found for the search criteria ');
            this.loader.hide();   
          }else{
            this.tspMailingListReport = CommonHelpers.sortAtoZ(mailReport);
            this.processDataFromService();
            this.loader.hide();
          }
        }, (error) => {
          this.errorMessage = error;
          this.alertService.error('No records found for the search criteria ');
          this.loader.hide();
        }
      );

    } else {
      this.reportsService.getCustomerMailReport(paramObj, this.order, this.reverse).subscribe(
        mailReport => {
          this.customerMailingListReport = mailReport;
          this.customerMailingListReport.sort(function (a:any, b:any) {
            if (a.agencyCode === b.agencyCode) {
              return  ( a.bureauCode - b.bureauCode);
            }
          });
          this.loader.hide();
        },
        (error) => {
          this.errorMessage = error;
          this.alertService.error('No records found for the query selection criteria ');
          this.loader.hide();
        }
      );
    }
  }

  // Construt the parameter object to send server side component.
  constructParamsObj() {
    const paramsObj = [];

    if (this.tspSelected) {
      if (this.radioSelectedValue === 'freightTSP') {
        paramsObj.push('freightTSP:' + true);
      }
      if (this.radioSelectedValue === 'hhGoodsTSP') {
        paramsObj.push('hhGoodsTSP:' + true);
      }
      if (this.mailingListForm.get('smartWay').value) {
        this.smartWaySelected = true;
        paramsObj.push('smartWay:' + this.mailingListForm.get('smartWay').value);
      }else{
        this.smartWaySelected = false;
      }
      if (this.mailingListForm.get('processingTsps').value) {
        //this.smartWaySelected = true;
        paramsObj.push('processingTsps:' + this.mailingListForm.get('processingTsps').value);
      }
      for (let i = 0; i < this.sociaEconomicIndicators.length; i++) {
        paramsObj.push(this.sociaEconomicIndicators[i].id + ':' + this.mailingListForm.get('sociaEconomicIndicators').value[i]);
      }
      for (let i = 0; i < this.offerings.length; i++) {
        paramsObj.push(this.offerings[i].serviceCode + ':' + this.mailingListForm.get('offerings').value[i]);
      }
    } else {
      paramsObj.push('agencyUser:' + this.mailingListForm.get('agencyCode').value);
      paramsObj.push('bureauUser:' + this.mailingListForm.get('bureauUser').value);
      paramsObj.push('freightUser:' + ((this.radioSelectedValue === 'freightUser')? true : null));
      paramsObj.push('hhGoodsUser:' + ((this.radioSelectedValue === 'hhGoodsUser')? true : null));
    }
    if (AppConstants.isNotNullCondition(this.mailingListForm.get('zipCode').value)) {
      paramsObj.push('zipCode:' + this.mailingListForm.get('zipCode').value);
    }
    return paramsObj;
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.columnAPI = params.columnApi;
    (this.freightTSPSelected === true) ? this.columnAPI.setColumnVisible('DomesticFRT', true) : this.columnAPI.setColumnVisible('DomesticFRT', false);
    if(this.hhgTSPSelected === true){
      this.columnAPI.setColumnVisible('DomesticHHG', true);
      this.columnAPI.setColumnVisible('ExtendedStorageHHG', true);
      this.columnAPI.setColumnVisible('InternationalHHG', true);
      this.columnAPI.setColumnVisible('descriptionColumn', false);
    }else{
      this.columnAPI.setColumnVisible('DomesticHHG', false);
      this.columnAPI.setColumnVisible('ExtendedStorageHHG', false);
      this.columnAPI.setColumnVisible('InternationalHHG', false);
    }

    this.showOrHideSmartWay(this.columnAPI);
    this.showOrHideIndicators(this.columnAPI, this.mailingListForm.get('sociaEconomicIndicators')?.value);

    setTimeout(() => {
      var paramsRefresh = {
        force: true,
        suppressFlash: true,
      };
      this.gridApi.refreshCells(paramsRefresh);
    }, 0)
  }

  showOrHideSmartWay(columApi: any){
    if(this.smartWaySelected === true){
      columApi.setColumnVisible('smartway',true);
    }else{
      columApi.setColumnVisible('smartway',false);
    }
  }

  showOrHideIndicators(columApi: any, arrIndicator: any){
    for (let index = 0; index < arrIndicator.length; index++) {
      const element = arrIndicator[index];
      switch(index){
        case 0:
            columApi.setColumnVisible('8a',arrIndicator[index]);
          break;
        case 1:
          columApi.setColumnVisible('d',arrIndicator[index]);
          break;
        case 2:
          columApi.setColumnVisible('dv',arrIndicator[index]);
          break;
        case 3:
          columApi.setColumnVisible('h',arrIndicator[index]);
          break;
        case 4:
          columApi.setColumnVisible('o',arrIndicator[index]);
          break;
        case 5:
          columApi.setColumnVisible('s',arrIndicator[index]);
          break;
        case 6:
          columApi.setColumnVisible('v',arrIndicator[index]);
          break;
        case 7:
          columApi.setColumnVisible('w',arrIndicator[index]);
          break;
        default:
          break;
      }
    }
  }

  getAllUsersList(organizationId?) {
    this.reportsService.getAllUsersMailReport(organizationId).subscribe(
      usersList => {
        this.allUsersMailListReport = usersList;
        this.malingListUsersModal.show();
      },
      (error) => {
        this.errorMessage = error;
        this.alertService.error('No records found for the search criteria ');
        this.loader.hide();
      }
    );

  }

  // Export table to excel file and download/save the file.
  exportData() {
    if (this.customerMailingListReport && this.customerMailingListReport.length > 0) {
      this.reportsService.customerMailReportExport(this.customerMailingListReport).subscribe(dfr => {
        const byteData: number[] = dfr.byteData;
        const fileName: string = dfr.fileName;
        const numRows: number = dfr.numberOfExcelRows;
        const bytes = new Uint8Array(byteData);
        const blob = new Blob([bytes], {
          type: null
        });
        FileSaver.saveAs(blob, fileName);
        this.alertService.success('Customer Mailing List Report Downloaded - ' + numRows + ' Records found');
      }, (error) => {
        this.alertService.error('Failed to Export Customer Mailing List Report');
      });
    } else if (this.tspMailingListReport && this.tspMailingListReport.length > 0) {
      this.reportsService.tspMailReportExport(this.tspMailingListReport).subscribe(dfr => {
        const byteData: number[] = dfr.byteData;
        const fileName: string = dfr.fileName;
        const numRows: number = dfr.numberOfExcelRows;
        const bytes = new Uint8Array(byteData);
        const blob = new Blob([bytes], {
          type: null
        });
        FileSaver.saveAs(blob, fileName);
        this.alertService.success('TSP Mailing List Report Downloaded - ' + numRows + ' Records found');
      }, (error) => {
        this.alertService.error('Failed to Export TSP Mailing List Report');
      });
    } else {
      this.alertService.warn('No Data to Export');
    }
  }

  // Export table to excel file and download/save the file.
  exportAllUsersData() {
    if (this.allUsersMailListReport && this.allUsersMailListReport.length > 0) {
      this.reportsService.usersListExport(this.allUsersMailListReport).subscribe(dfr => {
        const byteData: number[] = dfr.byteData;
        const fileName: string = dfr.fileName;
        const numRows: number = dfr.numberOfExcelRows;
        const bytes = new Uint8Array(byteData);
        const blob = new Blob([bytes], {
          type: null
        });
        FileSaver.saveAs(blob, fileName);
        this.alertService.success('Users Mailing List Report Downloaded - ' + numRows + ' Records found');
      }, (error) => {
        this.alertService.error('Failed to Export Users Mailing List Report');
      });
    } else {
      this.alertService.warn('No Data to Export');
    }
  }

   defaultExcelExportParams: ExcelExportParams= {
    autoConvertFormulas: true,
    processCellCallback: (params:any) => {
      const colfDef = params.column.getColDef();
      const nodeData = params?.node?.data;
     if(params?.column?.colDef?.cellRenderer){
       //geting colID
       if(colfDef?.colId === 'smartway'){
         return (nodeData?.smartWayId === 1) ? "yes" : "";
       }
       if(colfDef?.colId === '8a'){
         return (nodeData?.scacEconomicIndicatorList?.sbiCertified8a === "1") ? "yes" : "";
       }
       if(colfDef?.colId === 'd'){
         return (nodeData?.scacEconomicIndicatorList?.sbiCertifiedDisadvantged === "1") ? "yes" : "";
       }
       if(colfDef?.colId === 'dv'){
         return (nodeData?.scacEconomicIndicatorList?.serviceDisabledVetaranOwned === "1") ? "yes" : "";
       }
       if(colfDef?.colId === 'h'){
        return (nodeData?.scacEconomicIndicatorList?.sbiCertifiedHUBZone === "1") ? "yes": "";
       }
       if(colfDef?.colId === 'o'){
         return (nodeData?.scacEconomicIndicatorList?.otherThanSmallBuisness === "1") ? "yes" : "";
       }
       if(colfDef?.colId === 's'){
         return (nodeData?.scacEconomicIndicatorList?.smallBusiness === "1") ? "yes" : "";
       }
       if(colfDef?.colId === 'v'){
         return (nodeData?.scacEconomicIndicatorList?.vetaranOwnedBusiness === "1") ? "yes" : "";
       }
       if(colfDef?.colId === 'w'){
         return (nodeData?.scacEconomicIndicatorList?.womenOwnedBusiness === "1") ? "yes" : "";
       }
       if (colfDef?.colId === 'contact') {
         return params.value;
       }
      } else {
        return params.value;
      }
    },
  };
}
